import React from 'react';
import { connect } from 'react-redux';
import { Box, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { API_ROOT } from '../../../../baseUrls';
import Loader from '../../../organisms/loader/Loader';

class Usage extends React.Component {
  state = {
    usage: null,
  };

  componentDidMount() {
    fetch(`${API_ROOT}/mindfiles/${this.props.user.mid}/admin/usage`, {
      method: 'GET',
      credentials: 'include',
    })
    .then(resp => resp.json())
    .then(usage => this.setState({ usage }))
    .catch(error => console.error(error));
  }

  render() {
    if (!this.state.usage) {
      return <Loader />;
    }
    return (
      <Box>
        <h2>Logins</h2>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Users who logged in over the last:</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{backgroundColor: "#fff"}}>
            {this.state.usage.map((row, i) => (
              <TableRow key={i}>
                <TableCell key='ago'>{row.ago}</TableCell>
                <TableCell key='login'>{row.login}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <h2>Uploads</h2>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Uploads over the last:</TableCell>
              <TableCell>Submitted</TableCell>
              <TableCell>Processed</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{backgroundColor: "#fff"}}>
            {this.state.usage.map((row, i) => (
              <TableRow key={i}>
                <TableCell key='ago'>{row.ago}</TableCell>
                <TableCell key='submitted'>{row.submitted}</TableCell>
                <TableCell key='processed'>{row.processed}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth,
  };
}

export default connect(mapStateToProps)(Usage);